"use client";

import { useEffect, useState } from "react";
import { NavigationItem } from "@/components/NavigationItem";
import { useExperienciaProduto } from "@/components/ExperienciaProvider";
import { ITENS_PLATFORM_ADMIN, hrefPlatformAdmin, itemPlatformAdminAtivo } from "@/lib/platform-admin-navigation";
import { ORGANIZACAO_ADMINISTRADA_ALTERADA_EVENT, chaveOrganizacaoAdministrada } from "@/lib/programador-organizacao-preferencia";

export function PlatformAdminNavigation({ pathname, integrado = false }: { pathname: string; integrado?: boolean }) {
  const { dados } = useExperienciaProduto();
  const [organizacaoId, setOrganizacaoId] = useState("");

  useEffect(() => {
    const sincronizar = (evento?: Event) => {
      const escolha = (evento as CustomEvent<{ usuarioId: string; organizacaoId: string }> | undefined)?.detail;
      if (escolha && escolha.usuarioId === dados?.id && escolha.organizacaoId) {
        setOrganizacaoId(escolha.organizacaoId);
        return;
      }
      const query = pathname === "/admin" || pathname.startsWith("/admin/")
        ? new URLSearchParams(window.location.search).get("organizacaoId")?.trim()
        : "";
      let preferencia = "";
      try {
        if (dados?.id) preferencia = window.localStorage.getItem(chaveOrganizacaoAdministrada(dados.id)) ?? "";
      } catch { /* O menu ainda funciona sem storage. */ }
      setOrganizacaoId(query || preferencia);
    };
    sincronizar();
    window.addEventListener(ORGANIZACAO_ADMINISTRADA_ALTERADA_EVENT, sincronizar);
    return () => window.removeEventListener(ORGANIZACAO_ADMINISTRADA_ALTERADA_EVENT, sincronizar);
  }, [dados?.id, pathname]);

  const itens = ITENS_PLATFORM_ADMIN.map((item) => ({
    ...item,
    hrefDestino: hrefPlatformAdmin(item.href, organizacaoId),
    ativo: itemPlatformAdminAtivo(pathname, item.href),
  }));

  return (
    <>
      <aside data-platform-admin-sidebar="true" className={`hidden lg:block lg:flex-shrink-0 ${integrado ? "lg:w-[185px]" : "lg:w-[203px]"}`}>
        <div data-user-desktop-sidebar="true" className={`sticky flex flex-col border border-[var(--fz-sidebar-border)] bg-[var(--fz-sidebar-bg)] px-4 py-5 shadow-[var(--shadow-soft)] ${integrado ? "top-0 h-dvh rounded-none border-0 shadow-none" : "top-8 h-[calc(100dvh-4rem)] rounded-[24px]"}`}>
          <div className={`flex items-center gap-2 pb-4 ${integrado ? "" : "border-b border-[var(--fz-sidebar-divider)]"}`}>
            <div data-user-desktop-brand="true" className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-[14px] bg-[var(--fz-sidebar-brand-bg)] text-sm font-bold text-[var(--fz-sidebar-brand-text)]">PA</div>
            <div className="min-w-0">
              <p className="truncate text-[13px] font-semibold text-[var(--fz-sidebar-active-text)]">Administração</p>
              <p className="text-[11px] text-[var(--fz-sidebar-text)]">Plataforma</p>
            </div>
          </div>
          <nav aria-label="Administração da plataforma" className="mt-5 space-y-2 overflow-y-auto">
            {itens.map(({ href, hrefDestino, label, Icon, ativo }) => (
              <NavigationItem key={href} href={hrefDestino} label={label} Icon={Icon} active={ativo} />
            ))}
          </nav>
        </div>
      </aside>
      <nav data-user-mobile-navigation="true" aria-label="Administração da plataforma" className="fixed bottom-0 left-1/2 z-40 w-full max-w-[430px] -translate-x-1/2 overflow-x-auto border-t border-[var(--fz-sidebar-border)] bg-[var(--fz-sidebar-bg)] lg:hidden">
        <div className="flex min-w-max items-center gap-1 px-2 py-2">
          {itens.map(({ href, hrefDestino, label, Icon, ativo }) => (
            <div key={href} className="w-[74px] flex-none">
              <NavigationItem mobile href={hrefDestino} label={label} Icon={Icon} active={ativo} />
            </div>
          ))}
        </div>
      </nav>
    </>
  );
}
